import { ProtectionFactFind } from "@mojo/types/src/protection"
import useSWRMutation from "swr/mutation"

export const usePostLifeInsuranceData = useSWRMutation<
  Record<string, never> | undefined,
  any,
  any,
  ProtectionFactFind
>
